"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlaygroundProjectProperty = exports.playgroundProjectPropertyDefinition = void 0;
exports.playgroundProjectPropertyDefinition = {
    view: {
        label: 'Playground Project',
        hint: 'Insert the ID of the related sport / culture / media project. If you\'re not aware of these IDs, try the "Find Project" button. Sport and culture projects will automatically populate the Playground field below.',
    },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'playground-project',
};
const isPlaygroundProjectProperty = (prop) => {
    return prop.name === exports.playgroundProjectPropertyDefinition.name;
};
exports.isPlaygroundProjectProperty = isPlaygroundProjectProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxheWdyb3VuZC1wcm9qZWN0LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcGxheWdyb3VuZC1wcm9qZWN0LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLG9CQUFvQjtRQUMzQixJQUFJLEVBQUUsb05BQW9OO0tBQzNOO0lBQ0QsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLG9CQUFvQjtDQUNLLENBQUE7QUFJMUIsTUFBTSwyQkFBMkIsR0FBRyxDQUFDLElBQWtCLEVBQXFDLEVBQUU7SUFDbkcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDJDQUFtQyxDQUFDLElBQUksQ0FBQTtBQUMvRCxDQUFDLENBQUE7QUFGWSxRQUFBLDJCQUEyQiwrQkFFdkMifQ==